import script from "./charitySelection.vue?vue&type=script&setup=true&lang=js"
export * from "./charitySelection.vue?vue&type=script&setup=true&lang=js"

import "./charitySelection.vue?vue&type=style&index=0&id=e8ceb4d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8ceb4d4"]])

export default __exports__